import { __assign, __awaiter, __generator, __spreadArray } from "tslib";
import { event, eventTracker } from '../events/events.js';
import { pnmac_fetch, NewRelic } from 'pnmac-universal-components';
import { getCookie, getActiveFeatures } from '../../utils.js';
import { LocalStorage } from '../../LocalStorage/index.js';
import moment from 'moment';
import { trackEvent } from "../../Tealium";
export var LOG_IN = 'LOG_IN';
export var LOADING = 'LOADING';
export var ACCESS_TOKEN = 'ACCESS_TOKEN';
export var TOGGLE_DRAWER = "TOGGLE_DRAWER";
export var FETCH_LOAN = "FETCH_LOAN";
export var FETCH_LOAN_PAYMENT_SUPPLEMENT = "FETCH_LOAN_PAYMENT_SUPPLEMENT";
export var UPDATE_INFO = "UPDATE_INFO";
export var FETCH_LOANS = "FETCH_LOANS";
export var SELECT_LOAN = "SELECT_LOAN";
export var PUSH_NOTIFICATION_ASKED = 'PUSH_NOTIFICATION_ASKED';
export var FETCH_DOCUMENTS = "FETCH_DOCUMENTS";
export var FETCH_LASTPAYMNETRECEIVEDDATE = "FETCH_LASTPAYMNETRECEIVEDDATE";
export var UPDATE_MESSAGE_CENTER = "UPDATE_MESSAGE_CENTER";
export var UPDATE_LOAN_PREF = "UPDATE_PAPPERLESS";
export var LOAN_ACTIVITY = "LOAN_ACTIVITY";
export var PENNYWISE = "PENNYWISE";
export var UI_DATA = "UI_DATA";
export var FAQS = "FAQS";
export var REFRESHING = "REFRESHING";
export var GET_MESSAGES = "GET_MESSAGES";
export var CUSTOMER_OBJECT_MODEL = "CUSTOMER_OBJECT_MODEL";
export var DOC_TEMPLATES = "DOC_TEMPLATES";
export var LOAN_NUMBERS = "LOAN_NUMBERS";
export var FEATURE_TOGGLES = "FEATURE_TOGGLES";
export var FILTER_LOAN_ACTIVITY = "FILTER_LOAN_ACTIVITY";
export var SET_TOKEN = "SET_TOKEN";
export var TRANSACTION_TYPE = "TRANSACTION_TYPE";
export var POP_UPS = "POP_UPS";
export var CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export var OFFLINE_MODE = "OFFLINE_MODE";
export var OFFLINE_MODE_DETACH = "OFFLINE_MODE_DETACH";
export var E_DIS = "E_DIS";
export var url = function (penny) {
  return penny.pennyWise || penny.mobile ? urlValidation(penny.pennyHomeUrl) : '/';
};
export var TRANSACTION_CODES = "TRANSACTION_CODES";
export var EDIS_EL = "EDIS_EL";
export var MOD_TEMPLATES = "MOD_TEMPLATES";
export var FETCH_MODIFICATION = "FETCH_MODIFICATION";
export var CHAT_MESSAGES = "CHAT_MESSAGES";
export var SHOW_CHAT = "SHOW_CHAT";
export var CHAT_SESSION_DATA = "CHAT_SESSION_DATA";
export var CHAT_MINIMIZED = "CHAT_MINIMIZED";
export var MAIN_DISPATCH = "MAIN_DISPATCH";
export var PAYMENT_VALIDATION = 'PAYMENT_VALIDATION';
export var IDS_USER_PROFILE = "IDS_USER_PROFILE";
export var MOD_PORTAL_VISIBLE = "MOD_PORTAL_VISIBLE";
export var CLIENT_API_ROUTE = "CLIENT_API_ROUTE";
export var CHAT_SPEAKER_IS_ON = "CHAT_SPEAKER_IS_ON";
export var CHAT_IS_SPEAKING = "CHAT_IS_SPEAKING";
export var CHAT_MIC_IS_ON = "CHAT_MIC_IS_ON";
export var CHAT_IS_BLOCKED = "CHAT_IS_BLOCKED";
export var LOG_OUT = "LOG_OUT";
export var UPDATE_TITLE = "UPDATE_TITLE";
export var APP_SETTINGS = "APP_SETTINGS";
export var BILL_MATRIX = "BILL_MATRIX";
export var LIVE_AGENT_JOINED = "LIVE_AGENT_JOINED";
export var TRANSFER_TO_AGENT = "TRANSFER_TO_AGENT";
export var AGENT_SESSION_TOKEN = "AGENT_SESSION_TOKEN";
export var SAVE_WATSON_LATEST_MSG = "SAVE_WATSON_LATEST_MSG";
export var HIPPO_DATA = "HIPPO_DATA";
export var SIMPLYIOA_DATA = "SIMPLYIOA_DATA";
export var NACHA_BANKACCOUNT = "NACHA_BANKACCOUNT";
export var OFFERS = "OFFERS";
export var ASK_ENABLE_BIO = 'ASK_ENABLE_BIO';
export var GET_ESCROW_ANALYSIS_LOOKBACK = 'GET_ESCROW_ANALYSIS_LOOKBACK';
export var ESCROW_ANALYSIS_AVAILABLE = 'ESCROW_ANALYSIS_AVAILABLE';
export var BIO_WORKING = 'BIO_WORKING';
export var UPDATE_DEXP_MESSAGE_ENTRY = 'UPDATE_DEXP_MESSAGE_ENTRY';
export var DELETE_DEXP_MESSAGE_ENTRY = 'DELETE_DEXP_MESSAGE_ENTRY';
export var CREATE_DEXP_MESSAGE_ENTRY = 'CREATE_DEXP_MESSAGE_ENTRY';
export var REVIEWS = 'REVIEWS';
export var REFRESH_TRACKER_SESSION = 'REFRESH_TRACKER_SESSION';
export var FETCH_BORROWER_CONTACT_RULES = 'FETCH_BORROWER_CONTACT_RULES';
export var CLOSED_END_SECONDS = "CLOSED_END_SECONDS";
export var RESET_STATE = 'RESET_STATE';
export var EASY_SET_LOAN = 'EASY_SET_LOAN';
export var USER_IDLE_TIMEOUT = "USER_IDLE_TIMEOUT";
export var TAX_OPTIONS_AVAILABLE = "TAX_OPTIONS_AVAILABLE";
export var UPDATE_BOTTOM_TAB_ICON_COLOR = "UPDATE_BOTTOM_TAB_ICON_COLOR";
export var globalHeaders = function (state) {
  var header = {
    'Authorization': "Bearer ".concat(state.token),
    'Content-Type': 'application/json',
    'Passage': "".concat(state.passage || "DontNotLetThisInRestrictedZones"),
    'Pragma': 'no-cache',
    'Cache-Control': 'no-cache',
    'PennyTime': state.selectedLoanNumber,
    'TrackerSessionId': state.trackerSession
  };
  if (state.pennyWise) {
    header = __assign(__assign({}, header), {
      'pnmac_user': 'True'
    });
  }
  return header;
};
var proceed = function (data) {
  if (data.status == 200) {
    return data.json();
  } else {
    return null;
  }
};
function urlValidation(myUrl) {
  if (myUrl.substring(myUrl.length - 1) !== "/") {
    myUrl += "/";
  }
  return myUrl;
}
function is_url(str) {
  var regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
  if (regexp.test(str) || (str === null || str === void 0 ? void 0 : str.indexOf("localhost")) > -1) {
    return true;
  } else {
    return false;
  }
}
export var clearListCookies = function (params) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var loanid, url_1, urlParse;
      return __generator(this, function (_a) {
        loanid = getState().selectedLoanNumber;
        if (localStorage) {
          localStorage.setItem('currentLoanId', loanid);
        }
        if (parseInt(loanid) > 0) {
          if (params.loading) {
            dispatch({
              type: LOADING,
              act: true
            });
          }
          url_1 = "/oauth/logout?logout=".concat(params.logout, "&&loanId=").concat(loanid);
          if (!params.logout && is_url(params.nav)) {
            urlParse = new URL(params.nav);
            url_1 = "/oauth/logout?logout=".concat(params.logout, "&&path=").concat((urlParse === null || urlParse === void 0 ? void 0 : urlParse.pathname) + (urlParse === null || urlParse === void 0 ? void 0 : urlParse.search), "&&loanId=").concat(loanid);
          }
          pnmac_fetch(url_1, {
            retryDelay: function (attempt, error, response) {
              return Math.pow(2, attempt) * 1000;
            }
          }).then(function (res) {
            if (params.logout) {
              dispatch({
                type: LOG_OUT,
                logedIn: false
              });
            }
            if (res.status >= 200 && res.status < 300) {
              if (params.tab) {
                window.open(params.nav, "_blank");
              } else {
                window.location = params.nav;
              }
            }
            setTimeout(function () {
              dispatch({
                type: LOADING,
                act: false
              });
            }, 200000);
          });
        }
        return [2 /*return*/];
      });
    });
  };
};
export var syncNotificationKey = function (idsUser, deviceId, systemToken) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        fetch("".concat(url(getState()), "api/main/set_notification_key"), {
          method: 'POST',
          headers: globalHeaders(getState()),
          body: JSON.stringify({
            idsUserId: idsUser,
            deviceId: deviceId,
            systemToken: systemToken
          })
        }).then(function (res) {});
        return [2 /*return*/];
      });
    });
  };
};
export var authenticateBiometrics = function (idsUser, key, callback, deviceId) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        fetch("".concat(url(getState()), "api/main/bio_metric_auth_login"), {
          method: 'POST',
          headers: globalHeaders(getState()),
          body: JSON.stringify({
            idsUserId: idsUser,
            payload: key,
            deviceId: deviceId
          })
        }).then(function (res) {
          return res.text();
        }).then(function (da) {
          if (da) {
            callback(true, JSON.parse(da));
          } else {
            callback(false);
          }
        });
        return [2 /*return*/];
      });
    });
  };
};
export var fetchLoanPaymentSupplementInfo = function (id) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var ui, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(id && id !== undefined)) return [3 /*break*/, 3];
            return [4 /*yield*/, pnmac_fetch("".concat(url(getState()), "api/loan/paymentsupplements?loanId=") + id, {
              method: "GET",
              headers: globalHeaders(getState())
            })];
          case 1:
            ui = _a.sent();
            return [4 /*yield*/, ui.json()];
          case 2:
            data = _a.sent();
            dispatch({
              type: FETCH_LOAN_PAYMENT_SUPPLEMENT,
              data: data
            });
            _a.label = 3;
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };
};
export var fetchLoan = function (id) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var data, jsData;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(id && id !== undefined)) return [3 /*break*/, 3];
            return [4 /*yield*/, pnmac_fetch("".concat(url(getState()), "api/loan/loan"), {
              method: "POST",
              headers: globalHeaders(getState()),
              body: JSON.stringify({
                loanId: id
              })
            })];
          case 1:
            data = _a.sent();
            if (!(data.status === 200)) return [3 /*break*/, 3];
            return [4 /*yield*/, data.json()];
          case 2:
            jsData = _a.sent();
            dispatch({
              type: FETCH_LOAN,
              jsData: jsData
            });
            _a.label = 3;
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };
};
export var updateAppSettings = function (setting, value) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var appSettings;
      var _a;
      return __generator(this, function (_b) {
        appSettings = getState().appSettings;
        dispatch({
          type: APP_SETTINGS,
          appSettings: __assign(__assign({}, appSettings), (_a = {}, _a[setting] = value, _a.notificationDayOfMonth = value, _a))
        });
        return [2 /*return*/];
      });
    });
  };
};
export var trackerDispatcher = function (userLanguage, trackerCategoryLID, trackerHitTypeLID, trackerActionLID, label, value, jsonEventData, includeMobilePrefix) {
  if (includeMobilePrefix === void 0) {
    includeMobilePrefix = null;
  }
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var st, loanId, trackerSession, mobile, borrowerId, msrID, interactionID_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!!getState().pennyWise) return [3 /*break*/, 3];
            st = getState();
            loanId = st.selectedLoanNumber;
            trackerSession = st.trackerSession;
            mobile = includeMobilePrefix === null ? st.mobile : includeMobilePrefix;
            borrowerId = st.borrowerId;
            msrID = st.servicerId;
            if (!(loanId && borrowerId)) return [3 /*break*/, 3];
            if (!st.mobile) return [3 /*break*/, 2];
            if (typeof label === 'string') {
              label = label.replace('[[platform]]', "Mobile");
            }
            return [4 /*yield*/, NewRelic.startInteraction('TrackerDispatcher')];
          case 1:
            interactionID_1 = _a.sent();
            NewRelic.setAttribute('loanID', loanId);
            NewRelic.setAttribute('label', label);
            fetch("".concat(url(getState()), "api/main/publish_ui_tracker"), {
              method: 'POST',
              body: JSON.stringify(eventTracker(loanId, borrowerId, userLanguage, trackerCategoryLID, trackerHitTypeLID, trackerActionLID, label, value, jsonEventData, parseInt(trackerSession), mobile, msrID)),
              headers: globalHeaders(getState())
            }).then(function (res) {
              NewRelic.endInteraction(interactionID_1);
            }).catch(function (err) {
              NewRelic.endInteraction(interactionID_1);
            });
            NewRelic.removeAttribute('loanID');
            NewRelic.removeAttribute('label');
            return [3 /*break*/, 3];
          case 2:
            if (typeof label === 'string') {
              label = label.replace('[[platform]]', "Web");
            }
            NewRelic.trackInteraction('TrackerDispatcher', {}, true); // true for start
            NewRelic.setAttribute('loanID', loanId);
            NewRelic.setAttribute('label', label);
            fetch("".concat(url(getState()), "api/main/publish_ui_tracker"), {
              method: 'POST',
              body: JSON.stringify(eventTracker(loanId, borrowerId, userLanguage, trackerCategoryLID, trackerHitTypeLID, trackerActionLID, label, value, jsonEventData, parseInt(trackerSession), mobile, msrID)),
              headers: globalHeaders(getState())
            }).then(function (res) {
              NewRelic.trackInteraction('TrackerDispatcher', {}, false); // false for end
            }).catch(function (err) {
              NewRelic.trackInteraction('TrackerDispatcher', {}, false); // false for end
            });
            _a.label = 3;
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };
};
export var eventDispatcher = function (data, eventType, eventStatus, language) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var loanId;
      return __generator(this, function (_a) {
        loanId = getState().selectedLoanNumber;
        fetch("".concat(url(getState()), "api/main/publish_ui_event"), {
          method: 'POST',
          body: JSON.stringify(event(loanId, data, eventType, eventStatus, language)),
          headers: globalHeaders(getState())
        });
        return [2 /*return*/];
      });
    });
  };
};
export var fetchDocuments = function (id) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var dataDocs, jsDataDocs;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!id) return [3 /*break*/, 3];
            return [4 /*yield*/, pnmac_fetch("".concat(url(getState()), "api/documents/get_docs"), {
              method: "POST",
              headers: globalHeaders(getState()),
              body: JSON.stringify({
                loanId: id
              })
            })];
          case 1:
            dataDocs = _a.sent();
            if (!(dataDocs.status === 200)) return [3 /*break*/, 3];
            return [4 /*yield*/, dataDocs.json()];
          case 2:
            jsDataDocs = _a.sent();
            dispatch({
              type: FETCH_DOCUMENTS,
              jsDataDocs: jsDataDocs
            });
            _a.label = 3;
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };
};
export var ui_data = function () {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var state, ui, subServingUIData, subServingUI, e_1, uiData;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            state = getState();
            return [4 /*yield*/, pnmac_fetch("".concat(url(state), "api/main/ui_resources"), {
              method: "GET"
            })];
          case 1:
            ui = _a.sent();
            subServingUIData = [];
            if (!localStorage.getItem("currentLoanId")) return [3 /*break*/, 6];
            return [4 /*yield*/, pnmac_fetch("".concat(url(state), "api/main/ui_subserving_resources?loanId=") + localStorage.getItem("currentLoanId"), {
              method: "GET"
            })];
          case 2:
            subServingUI = _a.sent();
            _a.label = 3;
          case 3:
            _a.trys.push([3, 5,, 6]);
            return [4 /*yield*/, subServingUI.json()];
          case 4:
            subServingUIData = _a.sent();
            return [3 /*break*/, 6];
          case 5:
            e_1 = _a.sent();
            return [3 /*break*/, 6];
          case 6:
            return [4 /*yield*/, ui.json()];
          case 7:
            uiData = _a.sent();
            //// I need to come back to this
            dispatch({
              type: UI_DATA,
              uiData: __spreadArray(__spreadArray([], uiData || (state === null || state === void 0 ? void 0 : state.uiData), true), subServingUIData, true)
            });
            return [2 /*return*/];
        }
      });
    });
  };
};
export var pennyWiseAuth = function (token, urlPenny) {
  if (token === void 0) {
    token = null;
  }
  if (urlPenny === void 0) {
    urlPenny = null;
  }
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var state, urlRouted, ui, uiData, jsData, data2, jsData2, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            dispatch({
              type: ACCESS_TOKEN,
              token: token,
              logedIn: true,
              loanNumbers: "",
              userProfile: "",
              mobile: false
            });
            state = getState();
            urlRouted = urlPenny || url(state);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 7,, 8]);
            return [4 /*yield*/, pnmac_fetch("".concat(urlRouted, "api/main/ui_resources"), {
              method: "GET",
              headers: globalHeaders(state)
            })];
          case 2:
            ui = _a.sent();
            return [4 /*yield*/, ui.json()];
          case 3:
            uiData = _a.sent();
            dispatch({
              type: UI_DATA,
              uiData: uiData || (state === null || state === void 0 ? void 0 : state.uiData)
            });
            pnmac_fetch("".concat(url(getState()), "api/main/feature_toggles_ace"), {
              method: "GET",
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(function (s) {
              return proceed(s);
            }).then(function (features) {
              if (features) {
                dispatch({
                  type: FEATURE_TOGGLES,
                  features: features
                });
              }
            }).catch(function (e) {
              return console.log("Error getting request", e);
            });
            jsData = {
              loan_numbers: state.loanNumberWithCommas
            };
            return [4 /*yield*/, pnmac_fetch("".concat(urlRouted, "oauth/request_token_pen"), {
              method: "GET",
              headers: globalHeaders(state)
            })];
          case 4:
            data2 = _a.sent();
            return [4 /*yield*/, data2.json()];
          case 5:
            jsData2 = _a.sent();
            return [4 /*yield*/, getData(dispatch, getState, jsData)];
          case 6:
            _a.sent();
            dispatch({
              type: ACCESS_TOKEN,
              logedIn: true,
              url: jsData2.current_customer_dns
            });
            return [3 /*break*/, 8];
          case 7:
            err_1 = _a.sent();
            return [3 /*break*/, 8];
          case 8:
            return [2 /*return*/];
        }
      });
    });
  };
};
export var loanId_0 = function () {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        dispatch({
          type: "LOAN_ID_0",
          set: false
        });
        return [2 /*return*/];
      });
    });
  };
};
export var authenticate = function (registration) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var data, jsData, state, err_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            LocalStorage.getDataString("PennyTime").then(function (s) {
              if (s) {
                dispatch({
                  type: EASY_SET_LOAN,
                  loanId: !isNaN(s) ? parseInt(s) : 0
                });
              }
            });
            state = getState();
            if (!(!state.pennyWise && !registration)) return [3 /*break*/, 5];
            _a.label = 1;
          case 1:
            _a.trys.push([1, 4,, 5]);
            return [4 /*yield*/, pnmac_fetch("".concat(url(state), "api/account/request_token"), {
              method: "GET",
              retries: 4,
              retryOn: [333, 302],
              retryDelay: function (attempt, error, response) {
                return Math.pow(2, attempt) * 1000; // 1000, 2000, 4000
              },
              headers: __assign(__assign({}, state.token ? {
                'Authorization': "Bearer ".concat(state.token)
              } : null), {
                'Content-Type': 'application/json'
              })
            })];
          case 2:
            data = _a.sent();
            return [4 /*yield*/, data.json()];
          case 3:
            jsData = _a.sent();
            //googleAnalytics.setUser(jsData?.user_profile?.user_id, jsData?.user_profile)
            if (jsData.reviews) {
              dispatch({
                type: REVIEWS,
                reviews: jsData.reviews
              });
            }
            return [3 /*break*/, 5];
          case 4:
            err_2 = _a.sent();
            return [3 /*break*/, 5];
          case 5:
            if (!registration && (!(jsData === null || jsData === void 0 ? void 0 : jsData.user_access) || jsData.user_access == "") && !(state === null || state === void 0 ? void 0 : state.token)) {
              dispatch({
                type: ACCESS_TOKEN,
                token: "",
                logedIn: false
              });
              window.location.href = "/oauth/index?RetrunToUrlAce=".concat(window.location.pathname);
            }
            pnmac_fetch("".concat(url(getState()), "api/main/ui_resources"), {
              method: "GET",
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(function (s) {
              return proceed(s);
            }).then(function (uiData) {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  if (registration) {
                    dispatch({
                      type: ACCESS_TOKEN,
                      token: (jsData === null || jsData === void 0 ? void 0 : jsData.user_access) || (state === null || state === void 0 ? void 0 : state.token),
                      logedIn: true
                    });
                  }
                  dispatch({
                    type: UI_DATA,
                    uiData: uiData || getState().uiData
                  });
                  return [2 /*return*/];
                });
              });
            }).catch(function (e) {
              return console.log("Error getting request", e);
            });
            pnmac_fetch("".concat(url(getState()), "api/main/feature_toggles_ace"), {
              method: "GET",
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(function (s) {
              return proceed(s);
            }).then(function (features) {
              dispatch({
                type: FEATURE_TOGGLES,
                features: features
              });
            }).catch(function (e) {
              return console.log("Error getting request", e);
            });
            if (!((jsData === null || jsData === void 0 ? void 0 : jsData.is_logged_in) && !registration)) return [3 /*break*/, 7];
            if (!getState().pennyWise) {
              dispatch({
                type: ACCESS_TOKEN,
                segments: jsData.segments,
                server_time: jsData.server_time,
                token: (jsData === null || jsData === void 0 ? void 0 : jsData.user_access) || (state === null || state === void 0 ? void 0 : state.token),
                logedIn: true,
                loanNumbers: jsData.loan_numbers,
                userProfile: jsData.user_profile,
                url: jsData.current_customer_dns,
                movr_url: jsData.movr_url,
                index_borrower_id: jsData === null || jsData === void 0 ? void 0 : jsData.index_borrower_id,
                vapid: jsData === null || jsData === void 0 ? void 0 : jsData.vapid,
                live_agent_url: jsData === null || jsData === void 0 ? void 0 : jsData.live_agent_url,
                live_agent_flow: jsData === null || jsData === void 0 ? void 0 : jsData.live_agent_flow,
                live_agent_instance: jsData === null || jsData === void 0 ? void 0 : jsData.live_agent_instance,
                penny_home_url: jsData === null || jsData === void 0 ? void 0 : jsData.penny_home_url,
                state_id: jsData === null || jsData === void 0 ? void 0 : jsData.state_id,
                showComunicationPreferenceChangeBanner: jsData === null || jsData === void 0 ? void 0 : jsData.showComunicationPreferenceChangeBanner,
                mdm_id: jsData === null || jsData === void 0 ? void 0 : jsData.mdm_id,
                lender_details: jsData === null || jsData === void 0 ? void 0 : jsData.lender_details
              });
            }
            return [4 /*yield*/, getData(dispatch, getState, jsData)];
          case 6:
            _a.sent();
            _a.label = 7;
          case 7:
            return [2 /*return*/];
        }
      });
    });
  };
};
function getData(dispatch, getState, jsData) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
  return __awaiter(this, void 0, void 0, function () {
    var loanSummaryData, data, msrCode, servicingContractTypeId, defaultLoan, closedEndSeconds, state, defaultFAQ, thirdPartyFAQ_1, filteredFAQ, faqs_1, layout, state, loan, currentLoanId_1;
    return __generator(this, function (_t) {
      switch (_t.label) {
        case 0:
          if (!(((_a = jsData.loan_numbers) === null || _a === void 0 ? void 0 : _a.length) > 0 && jsData.loan_numbers)) return [3 /*break*/, 8];
          return [4 /*yield*/, pnmac_fetch("".concat(url(getState()), "api/loan/loans"), {
            method: "POST",
            headers: globalHeaders(getState()),
            retryOn: [302, 204, 400, 404],
            retryDelay: function (attempt, error, response) {
              return Math.pow(2, attempt) * 1000; // 1000, 2000, 4000
            },
            body: JSON.stringify({
              loanId: jsData.loan_numbers
            })
          })];
        case 1:
          data = _t.sent();
          msrCode = void 0;
          servicingContractTypeId = void 0;
          if (!(data.status >= 200 && data.status <= 299)) return [3 /*break*/, 4];
          return [4 /*yield*/, data.json()];
        case 2:
          loanSummaryData = _t.sent();
          if (!loanSummaryData) return [3 /*break*/, 4];
          return [4 /*yield*/, dispatch({
            type: FETCH_LOANS,
            jsData: loanSummaryData
          })];
        case 3:
          _t.sent();
          defaultLoan = loanSummaryData === null || loanSummaryData === void 0 ? void 0 : loanSummaryData.loanSummary.sort(function (a, b) {
            return new Date(b.loanAddedDate) - new Date(a.loanAddedDate);
          })[0];
          msrCode = (_b = defaultLoan === null || defaultLoan === void 0 ? void 0 : defaultLoan.organizationServicerSummary) === null || _b === void 0 ? void 0 : _b.msrCode;
          servicingContractTypeId = (_c = defaultLoan === null || defaultLoan === void 0 ? void 0 : defaultLoan.organizationServicerSummary) === null || _c === void 0 ? void 0 : _c.servicingContractTypeId;
          if ((_d = loanSummaryData === null || loanSummaryData === void 0 ? void 0 : loanSummaryData.loanSummary) === null || _d === void 0 ? void 0 : _d.some(function (t) {
            return parseInt(t.lienPriorityType) == 2;
          })) {
            closedEndSeconds = (_e = loanSummaryData === null || loanSummaryData === void 0 ? void 0 : loanSummaryData.loanSummary) === null || _e === void 0 ? void 0 : _e.find(function (t) {
              return parseInt(t.lienPriorityType) == 2;
            });
            pnmac_fetch("".concat(url(getState()), "api/payment/get_payment_info"), {
              method: "POST",
              headers: globalHeaders(getState()),
              retryOn: [302, 204],
              body: JSON.stringify({
                loanId: closedEndSeconds.loanId
              })
            }).then(function (data) {
              if (data.status == 200) {
                return data.json();
              }
            }).then(function (d) {
              dispatch({
                type: CLOSED_END_SECONDS,
                payment: d
              });
            });
          }
          if (msrCode != null && msrCode != "001") {
            pnmac_fetch("".concat(url(getState()), "api/main/ui_subserving_resources?loanId=") + defaultLoan.loanId, {
              method: "GET"
            }).then(function (s) {
              return s.json();
            }).then(function (data) {
              dispatch({
                type: UI_DATA,
                uiData: data
              });
            });
          }
          _t.label = 4;
        case 4:
          state = getState();
          if (state.segmentId !== null) {
            fetch("".concat(url(state), "api/main/offers?segmentId=").concat(state.segmentId), {
              method: "GET",
              headers: globalHeaders(getState())
            }).then(function (res) {
              return res.json();
            }).then(function (ress) {
              dispatch({
                type: OFFERS,
                offers: ress
              });
            });
          }
          pnmac_fetch("".concat(url(getState()), "api/loan/get_loan_activity"), {
            method: "POST",
            headers: globalHeaders(getState()),
            body: JSON.stringify({
              loanId: jsData.loan_numbers
            }),
            retryOn: [302, 204],
            retryDelay: function (attempt, error, response) {
              return Math.pow(2, attempt) * 1000; // 1000, 2000, 4000
            }
          }).then(function (data) {
            return proceed(data);
          }).then(function (res) {
            if (res) {
              dispatch({
                type: LOAN_ACTIVITY,
                loanActivity: res
              });
            }
          }).catch(function (e) {
            return console.log("Error getting request", e);
          });
          defaultFAQ = [];
          return [4 /*yield*/, fetch("".concat(url(getState()), "api/main/faqs"), {
            method: "GET",
            headers: globalHeaders(getState())
          }).then(function (data) {
            return data.json();
          })];
        case 5:
          defaultFAQ = _t.sent();
          thirdPartyFAQ_1 = [];
          if (!msrCode) return [3 /*break*/, 7];
          return [4 /*yield*/, fetch("".concat(url(getState()), "api/main/thirdparty_faqs?thirdParty=").concat(msrCode), {
            method: "GET",
            headers: globalHeaders(getState())
          }).then(function (data) {
            return data.json();
          }).catch(function (err) {})];
        case 6:
          thirdPartyFAQ_1 = _t.sent();
          _t.label = 7;
        case 7:
          filteredFAQ = [];
          if (defaultFAQ.length > 0) {
            // Checking if Loan is Private Label = 3 or Private Label Lite = 4, then hiding  "HELOC Loan" && "HELOC Préstamo" section from FAQ
            if (servicingContractTypeId === 3 || servicingContractTypeId === 4) {
              filteredFAQ = defaultFAQ === null || defaultFAQ === void 0 ? void 0 : defaultFAQ.filter(function (item) {
                return !item.englishTitle.includes("HELOC Loan") && !item.spanishTitle.includes("HELOC Préstamo");
              });
              filteredFAQ = filteredFAQ.map(function (t) {
                t.englishContent = t.englishContent.filter(function (u) {
                  return !u.title.includes("Payments using Debit Card");
                });
                t.spanishContent = t.spanishContent.filter(function (u) {
                  return !u.title.includes("Payments using Debit Card");
                });
                return t;
              });
            } else {
              filteredFAQ = defaultFAQ;
            }
          }
          faqs_1 = filteredFAQ.map(function (of, index) {
            if (thirdPartyFAQ_1.some(function (item) {
              return item.englishTitle === of.englishTitle;
            })) {
              var englishContentList = [];
              var spanishContentList = [];
              var thirdPartyContent = thirdPartyFAQ_1.filter(function (item) {
                return item.englishTitle === of.englishTitle;
              })[0];
              var findExist = of.englishContent.filter(function (item) {
                return thirdPartyContent.englishContent.some(function (it) {
                  return item.title === it.title;
                });
              });
              if (findExist.length > 0 && of.englishContent.length === thirdPartyContent.englishContent.length) {
                of.englishContent.forEach(function (englishObj, i) {
                  var subEnglishContent = thirdPartyContent.englishContent;
                  if (subEnglishContent.some(function (item) {
                    return item.title === englishObj.title;
                  })) {
                    englishContentList.push(subEnglishContent[i]);
                  } else {
                    englishContentList.push(englishObj);
                  }
                });
                of.spanishContent.forEach(function (spanishObj, i) {
                  var subSpanishContent = thirdPartyContent.spanishContent;
                  if (subSpanishContent.some(function (item) {
                    return item.title === spanishObj.title;
                  })) {
                    spanishContentList.push(subSpanishContent[i]);
                  } else {
                    spanishContentList.push(spanishObj);
                  }
                });
              } else {
                englishContentList = thirdPartyContent.englishContent.concat(of.englishContent);
                spanishContentList = thirdPartyContent.spanishContent.concat(of.spanishContent);
                var englishUnique = of.englishContent.reduce(function (acc, eachArr2Elem) {
                  if (thirdPartyContent.englishContent.findIndex(function (eachArr1Elem) {
                    return eachArr1Elem.title === eachArr2Elem.title;
                  }) === -1) {
                    acc.push(eachArr2Elem);
                  }
                  return acc;
                }, __spreadArray([], thirdPartyContent.englishContent, true));
                var spanishUnique = of.spanishContent.reduce(function (acc, eachArr2Elem) {
                  if (thirdPartyContent.spanishContent.findIndex(function (eachArr1Elem) {
                    return eachArr1Elem.title === eachArr2Elem.title;
                  }) === -1) {
                    acc.push(eachArr2Elem);
                  }
                  return acc;
                }, __spreadArray([], thirdPartyContent.englishContent, true));
                englishContentList = __spreadArray([], englishUnique, true);
                spanishContentList = __spreadArray([], spanishUnique, true);
              }
              return {
                englishTitle: of.englishTitle,
                englishContent: englishContentList,
                spanishContent: spanishContentList,
                spanishTitle: of.spanishTitle
              };
            }
            return of;
          });
          //adding extra faq from sub-servicing into default.
          thirdPartyFAQ_1.forEach(function (sub) {
            if (!faqs_1.find(function (a) {
              return a.englishTitle === sub.englishTitle;
            })) {
              faqs_1.push(sub);
            }
          });
          dispatch({
            type: FAQS,
            faqs: faqs_1
          });
          _t.label = 8;
        case 8:
          pnmac_fetch("".concat(url(getState()), "api/loan/get_transactionType"), {
            method: "GET",
            headers: globalHeaders(getState()),
            retryOn: [302, 204]
          }).then(function (data) {
            return proceed(data);
          }).then(function (res) {
            if (res) {
              dispatch({
                type: TRANSACTION_TYPE,
                transactionTypes: res
              });
            }
          }).catch(function (err) {
            return console.log(err);
          });
          pnmac_fetch("".concat(url(getState()), "api/modification/get_modform_templates"), {
            method: "GET",
            headers: globalHeaders(getState()),
            retryOn: [302, 204]
          }).then(function (data) {
            return proceed(data);
          }).then(function (res) {
            if (res) {
              dispatch({
                type: MOD_TEMPLATES,
                modTemplates: res
              });
            }
          }).catch(function (err) {
            return console.log(err);
          });
          layout = getState();
          if (getActiveFeatures(layout.features, "View_MessageCenter", layout.whitelisted)) {
            pnmac_fetch("".concat(url(getState()), "api/messages/get_messages"), {
              method: "GET",
              headers: globalHeaders(getState()),
              retryOn: [302, 204],
              retryDelay: function (attempt, error, response) {
                return Math.pow(2, attempt) * 1000; // 1000, 2000, 4000
              }
            }).then(function (data) {
              if (data.status == 200) {
                return data.json();
              } else {
                return null;
              }
            }).then(function (res) {
              if (res) {
                dispatch({
                  type: GET_MESSAGES,
                  messages: res
                });
              }
            }).catch(function (e) {
              return console.log("Error getting request", e);
            });
          }
          if (getActiveFeatures(layout.features, "DEXP_Messages", layout.whitelisted)) {
            state = getState();
            if (state.borrowerId !== null) {
              pnmac_fetch("".concat(url(getState()), "api/account/get_dexp_message_pennyContent_key"), {
                method: "POST",
                headers: globalHeaders(getState()),
                body: JSON.stringify({
                  borrowerId: state.borrowerId
                })
              }).then(function (data) {
                return data.text();
              }).then(function (res) {
                dispatch({
                  type: UPDATE_DEXP_MESSAGE_ENTRY,
                  pennyContentKey: res
                });
              }).catch(function (e) {
                return console.log("Error getting request", e);
              });
            }
          }
          if (jsData.loan_numbers && loanSummaryData) {
            loan = null;
            currentLoanId_1 = parseInt(getCookie("PennyTime"));
            if (currentLoanId_1 > 0 && !isNaN(currentLoanId_1)) {
              loan = loanSummaryData === null || loanSummaryData === void 0 ? void 0 : loanSummaryData.loanSummary.find(function (a) {
                return a.loanId == currentLoanId_1;
              });
            }
            if (!loan || loan == "undefined" || loan == null) {
              loan = loanSummaryData === null || loanSummaryData === void 0 ? void 0 : loanSummaryData.loanSummary.sort(function (a, b) {
                return new Date(b.loanAddedDate) - new Date(a.loanAddedDate);
              })[0];
            }
            if (parseInt(loan === null || loan === void 0 ? void 0 : loan.loanId) > 0) {
              pnmac_fetch("".concat(url(getState()), "api/loan/ValidateEscrowAnalysisShortage"), {
                method: "POST",
                headers: globalHeaders(getState()),
                body: JSON.stringify({
                  loanId: loan.loanId
                })
              }).then(function (data) {
                return data.json();
              }).then(function (res) {
                if (res) {
                  dispatch({
                    type: ESCROW_ANALYSIS_AVAILABLE,
                    isEscrowAnalysisEnabled: res
                  });
                }
              }).catch(function (err) {
                return console.log(err);
              });
              pnmac_fetch("".concat(url(getState()), "api/loan/paymentsupplements?loanId=") + (loan === null || loan === void 0 ? void 0 : loan.loanId), {
                method: "GET",
                headers: globalHeaders(getState())
              }).then(function (data) {
                if (data.status == 200) {
                  return data.json();
                } else {
                  return null;
                }
              }).then(function (res) {
                if (res) {
                  dispatch({
                    type: FETCH_LOAN_PAYMENT_SUPPLEMENT,
                    data: res
                  });
                }
              }).catch(function (e) {
                return console.log("Error getting request", e);
              });
              if (getActiveFeatures(layout.features, "View_SimplyIOA_Tile", false)) {
                fetch("".concat(url(getState()), "api/simplyIOA/get_simplyIOAData?loanId=").concat(loan.loanId), {
                  method: 'GET',
                  headers: globalHeaders(getState())
                }).then(function (s) {
                  if (s.status == 200 || s.status == 201) {
                    return s.json();
                  }
                  return null;
                }).then(function (w) {
                  if (w) {
                    dispatch({
                      type: SIMPLYIOA_DATA,
                      simplyIOAData: w
                    });
                  }
                }).catch(function (error) {
                  console.error('Error:', error);
                  // Handle the error here
                });
              }
              pnmac_fetch("".concat(url(getState()), "api/main/monthly_payment_transaction"), {
                method: "POST",
                headers: globalHeaders(getState()),
                body: JSON.stringify({
                  loanId: loan.loanId
                })
              }).then(function (data) {
                return proceed(data);
              }).then(function (res) {
                if (res) {
                  dispatch({
                    type: FETCH_LASTPAYMNETRECEIVEDDATE,
                    PaymentReceivedDate: res
                  });
                }
              }).catch(function (err) {
                return null;
              } //console.log(err)
              );
              pnmac_fetch("".concat(url(getState()), "api/payment/get_EdisbursementLoanEligibility"), {
                method: "POST",
                retryOn: [302, 204],
                headers: globalHeaders(getState()),
                body: JSON.stringify({
                  loanId: loan.loanId
                })
              }).then(function (res) {
                return proceed(res);
              }).then(function (data) {
                if (data) {
                  dispatch({
                    type: EDIS_EL,
                    dis: data
                  });
                } else dispatch({
                  type: EDIS_EL,
                  dis: data
                });
              }).catch(function (e) {
                return console.log("Error getting request", e);
              });
              pnmac_fetch("".concat(url(getState()), "api/documents/get_docs"), {
                method: "POST",
                headers: globalHeaders(getState()),
                body: JSON.stringify({
                  loanId: loan.loanId
                })
              }).then(function (data) {
                return proceed(data);
              }).then(function (res) {
                if (res) {
                  dispatch({
                    type: FETCH_DOCUMENTS,
                    jsDataDocs: res
                  });
                }
              }).catch(function (err) {
                return console.log(err);
              });
              fetch("".concat(url(getState()), "api/payment/get_bank_accounts"), {
                method: "POST",
                headers: globalHeaders(getState()),
                body: JSON.stringify({
                  loanId: loan.loanId
                })
              }).then(function (data) {
                return data.json();
              }).then(function (res) {
                if (res) {
                  dispatch({
                    type: E_DIS,
                    banksToAdd: res
                  });
                }
              }).catch(function (err) {
                return console.log(err);
              });
              pnmac_fetch("".concat(url(getState()), "api/payment/get_payment_info"), {
                method: "POST",
                headers: globalHeaders(getState()),
                retryOn: [302, 204],
                body: JSON.stringify({
                  loanId: loan.loanId
                })
              }).then(function (data) {
                if (data.status == 200) {
                  return data.json();
                }
              }).then(function (res) {
                if (res) {
                  if (res.isModPortalVisible == true) {
                    pnmac_fetch("".concat(url(getState()), "api/modification/get_modification_by_loanId"), {
                      method: "POST",
                      headers: globalHeaders(getState()),
                      retryOn: [302, 204],
                      body: JSON.stringify({
                        loanId: jsData.loan_numbers
                      })
                    }).then(function (data) {
                      if (data.status == 200) {
                        return data.json();
                      }
                    }).then(function (res) {
                      if (res) {
                        dispatch({
                          type: FETCH_MODIFICATION,
                          modifications: res,
                          modLoaded: true
                        });
                      } else {
                        dispatch({
                          type: FETCH_MODIFICATION,
                          modifications: null,
                          modLoaded: true
                        });
                      }
                    }).catch(function (e) {
                      dispatch({
                        type: FETCH_MODIFICATION,
                        modLoaded: true
                      });
                      console.log("Error getting request", e);
                    });
                  } else {
                    dispatch({
                      type: FETCH_MODIFICATION,
                      modifications: null,
                      modLoaded: true
                    });
                  }
                  dispatch({
                    type: PAYMENT_VALIDATION,
                    payment: res,
                    paymentInfo: true
                  });
                }
              }).catch(function (e) {
                return console.log("Error getting request", e);
              });
              if ((loan === null || loan === void 0 ? void 0 : loan.propertyRegion) === 'TX') {
                pnmac_fetch("".concat(url(getState()), "api/loan/get_selected_tax_options?loanId=").concat(loan.loanId), {
                  method: "GET",
                  headers: globalHeaders(getState())
                }).then(function (s) {
                  return s.json();
                }).then(function (data) {
                  dispatch({
                    type: TAX_OPTIONS_AVAILABLE,
                    taxOptionAvailable: data !== 0
                  });
                }).catch(function (err) {
                  dispatch({
                    type: TAX_OPTIONS_AVAILABLE,
                    taxOptionAvailable: false
                  });
                });
              }
            }
            trackEvent('store_info', {
              user_id: (_g = (_f = jsData === null || jsData === void 0 ? void 0 : jsData.user_profile) === null || _f === void 0 ? void 0 : _f.user_id) !== null && _g !== void 0 ? _g : '',
              borrower_id: Number((_h = jsData === null || jsData === void 0 ? void 0 : jsData.index_borrower_id) !== null && _h !== void 0 ? _h : 0),
              customer_id: Number((_k = (_j = jsData === null || jsData === void 0 ? void 0 : jsData.user_profile) === null || _j === void 0 ? void 0 : _j.customer_id) !== null && _k !== void 0 ? _k : 0),
              customer_email: (_o = (_m = (_l = loan === null || loan === void 0 ? void 0 : loan.borrowerSummary) === null || _l === void 0 ? void 0 : _l.find(function (x) {
                return x;
              })) === null || _m === void 0 ? void 0 : _m.borrowerEmailAddress) !== null && _o !== void 0 ? _o : '',
              customer_verified_email: (_q = (_p = jsData === null || jsData === void 0 ? void 0 : jsData.user_profile) === null || _p === void 0 ? void 0 : _p.verified_email) !== null && _q !== void 0 ? _q : '',
              user_name: (_s = (_r = jsData === null || jsData === void 0 ? void 0 : jsData.user_profile) === null || _r === void 0 ? void 0 : _r.username) !== null && _s !== void 0 ? _s : '',
              segment_id: Number(layout.segmentId || 0),
              loan_number: Number(jsData.loan_numbers || 0)
            });
          }
          return [2 /*return*/, true];
      }
    });
  });
}
export var refreshMessages = function (func) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        pnmac_fetch("".concat(url(getState()), "api/messages/get_messages"), {
          method: "GET",
          headers: globalHeaders(getState()),
          retryDelay: function (attempt, error, response) {
            return Math.pow(2, attempt) * 1000; // 1000, 2000, 4000
          }
        }).then(function (data) {
          return proceed(data);
        }).then(function (res) {
          if (res) {
            dispatch({
              type: GET_MESSAGES,
              messages: res
            });
            if (func) {
              func();
            }
          }
        }).catch(function (e) {
          return console.log("Error getting request", e);
        });
        return [2 /*return*/];
      });
    });
  };
};
export var refreshResourcesAfterLoanSwitching = function () {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var state, subServingUI, subServingUIData, servicingContractTypeId, e_2, msrCode, defaultFAQ, thirdPartyFAQ, filteredFAQ, faqs;
      var _a, _b, _c, _d;
      return __generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            state = getState();
            return [4 /*yield*/, pnmac_fetch("".concat(url(getState()), "api/main/ui_subserving_resources?loanId=") + ((_a = state.currentLoan) === null || _a === void 0 ? void 0 : _a.loanId), {
              method: "GET"
            })];
          case 1:
            subServingUI = _e.sent();
            subServingUIData = [];
            _e.label = 2;
          case 2:
            _e.trys.push([2, 4,, 5]);
            return [4 /*yield*/, subServingUI.json()];
          case 3:
            subServingUIData = _e.sent();
            return [3 /*break*/, 5];
          case 4:
            e_2 = _e.sent();
            return [3 /*break*/, 5];
          case 5:
            dispatch({
              type: UI_DATA,
              uiData: subServingUIData
            });
            msrCode = (_c = (_b = state.currentLoan) === null || _b === void 0 ? void 0 : _b.organizationServicerSummary) === null || _c === void 0 ? void 0 : _c.msrCode;
            servicingContractTypeId = (_d = defaultLoan === null || defaultLoan === void 0 ? void 0 : defaultLoan.organizationServicerSummary) === null || _d === void 0 ? void 0 : _d.servicingContractTypeId;
            defaultFAQ = [];
            return [4 /*yield*/, fetch("".concat(url(getState()), "api/main/faqs"), {
              method: "GET",
              headers: globalHeaders(getState())
            }).then(function (data) {
              return data.json();
            })];
          case 6:
            defaultFAQ = _e.sent();
            thirdPartyFAQ = [];
            if (!msrCode) return [3 /*break*/, 8];
            return [4 /*yield*/, fetch("".concat(url(getState()), "api/main/thirdparty_faqs?thirdParty=").concat(msrCode), {
              method: "GET",
              headers: globalHeaders(getState())
            }).then(function (data) {
              return data.json();
            }).catch(function (err) {})];
          case 7:
            thirdPartyFAQ = _e.sent();
            _e.label = 8;
          case 8:
            filteredFAQ = [];
            if (defaultFAQ.length > 0) {
              // Checking if Loan is Private Label = 3 or Private Label Lite = 4, then hiding  "HELOC Loan" && "HELOC Préstamo" section from FAQ
              if (servicingContractTypeId === 3 || servicingContractTypeId === 4) {
                filteredFAQ = defaultFAQ === null || defaultFAQ === void 0 ? void 0 : defaultFAQ.filter(function (item) {
                  return !item.englishTitle.includes("HELOC Loan") && !item.spanishTitle.includes("HELOC Préstamo");
                });
              } else {
                filteredFAQ = defaultFAQ;
              }
            }
            faqs = filteredFAQ.map(function (of, index) {
              if (thirdPartyFAQ.some(function (item) {
                return item.englishTitle === of.englishTitle;
              })) {
                var englishContentList = [];
                var spanishContentList = [];
                var thirdPartyContent = thirdPartyFAQ.filter(function (item) {
                  return item.englishTitle === of.englishTitle;
                })[0];
                var findExist = of.englishContent.filter(function (item) {
                  return thirdPartyContent.englishContent.some(function (it) {
                    return item.title === it.title;
                  });
                });
                if (findExist.length > 0 && of.englishContent.length === thirdPartyContent.englishContent.length) {
                  of.englishContent.forEach(function (englishObj, i) {
                    var subEnglishContent = thirdPartyContent.englishContent;
                    if (subEnglishContent.some(function (item) {
                      return item.title === englishObj.title;
                    })) {
                      englishContentList.push(subEnglishContent[i]);
                    } else {
                      englishContentList.push(englishObj);
                    }
                  });
                  of.spanishContent.forEach(function (spanishObj, i) {
                    var subSpanishContent = thirdPartyContent.spanishContent;
                    if (subSpanishContent.some(function (item) {
                      return item.title === spanishObj.title;
                    })) {
                      spanishContentList.push(subSpanishContent[i]);
                    } else {
                      spanishContentList.push(spanishObj);
                    }
                  });
                } else {
                  englishContentList = thirdPartyContent.englishContent.concat(of.englishContent);
                  spanishContentList = thirdPartyContent.spanishContent.concat(of.spanishContent);
                  var englishUnique = of.englishContent.reduce(function (acc, eachArr2Elem) {
                    if (thirdPartyContent.englishContent.findIndex(function (eachArr1Elem) {
                      return eachArr1Elem.title === eachArr2Elem.title;
                    }) === -1) {
                      acc.push(eachArr2Elem);
                    }
                    return acc;
                  }, __spreadArray([], thirdPartyContent.englishContent, true));
                  var spanishUnique = of.spanishContent.reduce(function (acc, eachArr2Elem) {
                    if (thirdPartyContent.spanishContent.findIndex(function (eachArr1Elem) {
                      return eachArr1Elem.title === eachArr2Elem.title;
                    }) === -1) {
                      acc.push(eachArr2Elem);
                    }
                    return acc;
                  }, __spreadArray([], thirdPartyContent.englishContent, true));
                  englishContentList = __spreadArray([], englishUnique, true);
                  spanishContentList = __spreadArray([], spanishUnique, true);
                }
                return {
                  englishTitle: of.englishTitle,
                  englishContent: englishContentList,
                  spanishContent: spanishContentList,
                  spanishTitle: of.spanishTitle
                };
              }
              return of;
            });
            //adding extra faq from sub-seriving into default.
            thirdPartyFAQ.forEach(function (sub) {
              if (!faqs.find(function (a) {
                return a.englishTitle === sub.englishTitle;
              })) {
                faqs.push(sub);
              }
            });
            dispatch({
              type: FAQS,
              faqs: faqs
            });
            return [2 /*return*/];
        }
      });
    });
  };
};
export var refreshLoanData = function (loanid, func) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var data, loanSummaryData;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, pnmac_fetch("".concat(url(getState()), "api/loan/loans"), {
              method: "POST",
              headers: globalHeaders(getState()),
              body: JSON.stringify({
                loanId: loanid
              }),
              retryOn: [302, 204, 400, 404],
              retryDelay: function (attempt, error, response) {
                return Math.pow(2, attempt) * 1000; // 1000, 2000, 4000
              }
            })];
          case 1:
            data = _a.sent();
            if (!(data.status >= 200 && data.status <= 299)) return [3 /*break*/, 3];
            return [4 /*yield*/, data.json()];
          case 2:
            loanSummaryData = _a.sent();
            if (loanSummaryData) {
              dispatch({
                type: FETCH_LOANS,
                jsData: loanSummaryData
              });
            }
            _a.label = 3;
          case 3:
            if (func) {
              func();
            }
            return [2 /*return*/];
        }
      });
    });
  };
};
export var getBanks = function (func, loanId) {
  if (func === void 0) {
    func = function () {
      return null;
    };
  }
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        fetch("".concat(url(getState()), "api/payment/get_all_bank_accounts"), {
          method: "POST",
          headers: globalHeaders(getState()),
          body: JSON.stringify({
            loanId: loanId
          })
        }).then(function (data) {
          return proceed(data);
        }).then(function (res) {
          if (res) {
            var cur = getState();
            dispatch({
              type: PAYMENT_VALIDATION,
              payment: __assign(__assign({}, cur.paymentModel), {
                bankAccounts: res
              }),
              paymentInfo: false
            });
            if (func) {
              func();
            }
          }
        }).catch(function (err) {
          return console.log(err);
        });
        return [2 /*return*/];
      });
    });
  };
};
export var review_request = function () {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var state, userid, pendingPayment;
      var _a;
      return __generator(this, function (_b) {
        state = getState();
        userid = state.userProfile.user_id;
        pendingPayment = (_a = state.paymentModel) === null || _a === void 0 ? void 0 : _a.pendingPayments.sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.effectiveDate) - new Date(a.effectiveDate);
        })[0];
        fetch("".concat(url(getState()), "api/main/review_stats?userId=").concat(userid, "&effectiveDate=").concat(moment(pendingPayment.effectiveDate).format("MM/DD/YYYY")), {
          method: 'GET',
          headers: globalHeaders(getState())
        }).then(function (js) {
          return js.json();
        }).then(function (res) {
          dispatch({
            type: REVIEWS,
            reviews: res
          });
        });
        return [2 /*return*/];
      });
    });
  };
};
export var refreshBankData = function (loanid, func) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        pnmac_fetch("".concat(url(getState()), "api/payment/get_payment_info"), {
          method: "POST",
          headers: globalHeaders(getState()),
          retryOn: [302, 204],
          body: JSON.stringify({
            loanId: loanid
          })
        }).then(function (data) {
          if (data.status == 200) {
            return data.json();
          }
        }).then(function (res) {
          if (res) {
            dispatch({
              type: PAYMENT_VALIDATION,
              payment: res,
              paymentInfo: true
            });
            if (func) {
              func();
            }
          }
        }).catch(function (e) {
          return console.log("Error getting request", e);
        });
        pnmac_fetch("".concat(url(getState()), "api/loan/get_loan_activity"), {
          method: "POST",
          headers: globalHeaders(getState()),
          body: JSON.stringify({
            loanId: loanid
          }),
          retryOn: [302, 204],
          retryDelay: function (attempt, error, response) {
            return Math.pow(2, attempt) * 1000; // 1000, 2000, 4000
          }
        }).then(function (data) {
          return proceed(data);
        }).then(function (res) {
          if (res) {
            dispatch({
              type: LOAN_ACTIVITY,
              loanActivity: res
            });
          }
        }).catch(function (e) {
          return console.log("Error getting request", e);
        });
        return [2 /*return*/];
      });
    });
  };
};
export var updatePayment = function (payment) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var layout, paymentModel, rindex, rindexeffective;
      return __generator(this, function (_a) {
        layout = getState();
        if (payment) {
          paymentModel = __assign({}, layout.paymentModel);
          if (paymentModel && paymentModel.pendingPayments.length > 0) {
            rindex = paymentModel.pendingPayments.findIndex(function (s) {
              return s.achConfigurationKey == payment.achConfigurationKey;
            });
            if (rindex > -1) {
              paymentModel.pendingPayments.splice(rindex, 1);
            }
            rindexeffective = paymentModel.pendingPayments.findIndex(function (s) {
              return moment(s.effectiveDate).format("MM/DD/YYYY") == moment(payment.effectiveDate).format("MM/DD/YYYY");
            });
            if (rindexeffective > -1) {
              paymentModel.pendingPayments.splice(rindexeffective, 1);
            }
            paymentModel.pendingPayments.push(payment);
            dispatch({
              type: PAYMENT_VALIDATION,
              payment: paymentModel
            });
          } else if (paymentModel) {
            paymentModel.pendingPayments = [];
            paymentModel.pendingPayments.push(payment);
            dispatch({
              type: PAYMENT_VALIDATION,
              payment: paymentModel
            });
          }
        }
        return [2 /*return*/];
      });
    });
  };
};
export var refreshSingleLoanData = function (loanId, func, bank) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var state;
      return __generator(this, function (_a) {
        state = getState();
        if (parseInt(loanId) > 0) {
          if (state.segmentId !== null) {
            fetch("".concat(url(state), "api/main/offers?segmentId=").concat(state.segmentId), {
              method: "GET",
              headers: globalHeaders(getState())
            }).then(function (res) {
              return res.json();
            }).then(function (res) {
              dispatch({
                type: OFFERS,
                offers: res
              });
            });
          }
          pnmac_fetch("".concat(url(getState()), "api/modification/get_modification_by_loanId"), {
            method: "POST",
            headers: globalHeaders(getState()),
            body: JSON.stringify({
              loanId: loanId
            })
          }).then(function (data) {
            return proceed(data);
          }).then(function (res) {
            if (res) {
              if (func && !bank) {
                func();
              }
              dispatch({
                type: FETCH_MODIFICATION,
                modifications: res,
                modLoaded: true
              });
            } else {
              dispatch({
                type: FETCH_MODIFICATION,
                modifications: null,
                modLoaded: true
              });
            }
          }).catch(function (e) {
            dispatch({
              type: FETCH_MODIFICATION,
              modLoaded: true
            });
            //console.log("Error getting request", e)
          });
          fetch("".concat(url(getState()), "api/documents/get_docs"), {
            method: "POST",
            headers: globalHeaders(getState()),
            body: JSON.stringify({
              loanId: loanId
            })
          }).then(function (data) {
            return data.json();
          }).then(function (res) {
            if (res) {
              dispatch({
                type: FETCH_DOCUMENTS,
                jsDataDocs: res
              });
            }
          }).catch(function (err) {
            return console.log(err);
          });
          pnmac_fetch("/api/payment/get_EdisbursementLoanEligibility", {
            method: "POST",
            headers: globalHeaders(getState()),
            body: JSON.stringify({
              loanId: loanId
            })
          }).then(function (res) {
            return proceed(res);
          }).then(function (data) {
            if (data) {
              dispatch({
                type: EDIS_EL,
                dis: data
              });
            } else dispatch({
              type: EDIS_EL,
              dis: data
            });
          }).catch(function (e) {
            return console.log("Error getting request", e);
          });
          fetch("".concat(url(getState()), "api/payment/get_bank_accounts"), {
            method: "POST",
            headers: globalHeaders(getState()),
            body: JSON.stringify({
              loanId: loanId
            })
          }).then(function (data) {
            return data.json();
          }).then(function (res) {
            if (res) {
              dispatch({
                type: E_DIS,
                banksToAdd: res
              });
            } else dispatch({
              type: EDIS_EL,
              banksToAdd: res
            });
          }).catch(function (err) {
            return console.log(err);
          });
          pnmac_fetch("".concat(url(getState()), "api/payment/get_payment_info"), {
            method: "POST",
            headers: globalHeaders(getState()),
            retryOn: [302, 204],
            body: JSON.stringify({
              loanId: loanId
            })
          }).then(function (data) {
            if (data.status == 200) {
              return data.json();
            }
          }).then(function (res) {
            if (res) {
              dispatch({
                type: PAYMENT_VALIDATION,
                payment: res,
                paymentInfo: true
              });
              if (func) {
                func();
              }
            }
          }).catch(function (e) {
            return console.log("Error getting request", e);
          });
          if (getActiveFeatures(state.features, "DEXP_Messages", state.whitelisted)) {
            if (state.borrowerId !== null) {
              pnmac_fetch("".concat(url(getState()), "api/account/get_dexp_message_pennyContent_key"), {
                method: "POST",
                headers: globalHeaders(getState()),
                body: JSON.stringify({
                  borrowerId: state.borrowerId
                })
              }).then(function (data) {
                return data.text();
              }).then(function (res) {
                dispatch({
                  type: UPDATE_DEXP_MESSAGE_ENTRY,
                  pennyContentKey: res
                });
              }).catch(function (e) {
                return console.log("Error getting request", e);
              });
            }
          }
          pnmac_fetch("".concat(url(getState()), "api/main/monthly_payment_transaction"), {
            method: "POST",
            headers: globalHeaders(getState()),
            body: JSON.stringify({
              loanId: loanId
            })
          }).then(function (data) {
            return proceed(data);
          }).then(function (res) {
            if (res) {
              dispatch({
                type: FETCH_LASTPAYMNETRECEIVEDDATE,
                PaymentReceivedDate: res
              });
            }
          }).catch(function (err) {
            return null;
          } //console.log(err)
          );
          pnmac_fetch("".concat(url(getState()), "api/loan/paymentsupplements?loanId=") + loanId, {
            method: "GET",
            headers: globalHeaders(getState())
          }).then(function (data) {
            if (data.status == 200) {
              return data.json();
            } else {
              return null;
            }
          }).then(function (res) {
            if (res) {
              dispatch({
                type: FETCH_LOAN_PAYMENT_SUPPLEMENT,
                data: res
              });
            }
          }).catch(function (e) {
            return console.log("Error getting request", e);
          });
        }
        return [2 /*return*/];
      });
    });
  };
};
export var get_user_profile = function (func) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var data, jsData;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, fetch("".concat(url(getState()), "api/account/request_token"), {
              method: "GET",
              headers: globalHeaders(getState())
            })];
          case 1:
            data = _a.sent();
            return [4 /*yield*/, data.json()];
          case 2:
            jsData = _a.sent();
            if (jsData.user_access && jsData.user_access !== "") {
              dispatch({
                type: ACCESS_TOKEN,
                token: jsData.user_access,
                logedIn: true,
                loanNumbers: jsData.loan_numbers,
                userProfile: jsData.user_profile,
                index_borrower_id: jsData === null || jsData === void 0 ? void 0 : jsData.index_borrower_id
              });
            }
            if (func) {
              func();
            }
            return [2 /*return*/];
        }
      });
    });
  };
};
export var transactionCodes = function (id) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var codes, jsCodes;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!id) return [3 /*break*/, 3];
            return [4 /*yield*/, fetch("".concat(url(getState()), "api/loan/get_transactionCodes?transactionTypeId=").concat(id), {
              method: "GET",
              headers: globalHeaders(getState())
            })];
          case 1:
            codes = _a.sent();
            if (!(codes.status === 200)) return [3 /*break*/, 3];
            return [4 /*yield*/, codes.json()];
          case 2:
            jsCodes = _a.sent();
            dispatch({
              type: TRANSACTION_CODES,
              transactionCodes: jsCodes
            });
            _a.label = 3;
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };
};
//// Mobile Specific
export var getDeviceInformation = function (deviceId, route, func) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var isBioEnabled, url;
      var _a, _b;
      return __generator(this, function (_c) {
        isBioEnabled = (_b = (_a = getState()) === null || _a === void 0 ? void 0 : _a.appSettings) === null || _b === void 0 ? void 0 : _b.isBioEnabled;
        console.log("isBioEnabled", isBioEnabled);
        url = "".concat(route, "/api/main/device_information?deviceId=").concat(deviceId, "&&idsUserId=").concat(getState().userProfile.user_id);
        if (isBioEnabled) {
          url += "&&isBioEnabled=".concat(isBioEnabled);
        }
        pnmac_fetch(url, {
          method: "GET",
          headers: globalHeaders(getState()),
          retryOn: [302, 204, 404]
        }).then(function (data) {
          if (data.status == 200) {
            return data.json();
          }
        }).then(function (res) {
          var _a;
          if (res) {
            dispatch({
              type: IDS_USER_PROFILE,
              userProfile: __assign(__assign({}, getState().userProfile), {
                user_id: ((_a = getState().userProfile) === null || _a === void 0 ? void 0 : _a.user_id) || res.idsUserId
              })
            });
            dispatch({
              type: FEATURE_TOGGLES,
              features: res.features
            });
            dispatch({
              type: APP_SETTINGS,
              appSettings: __assign(__assign({}, getState().appSettings), {
                isBioEnabled: res.bioEnabled
              })
            });
            if (res.bioEnabled) {
              dispatch({
                type: ASK_ENABLE_BIO
              });
            }
            if (func) {
              func(true);
            }
          } else {
            if (func) {
              func(false);
            }
          }
        }).catch(function (e) {
          if (func) {
            func(false);
          }
        });
        return [2 /*return*/];
      });
    });
  };
};
export var syncBiometricsKey = function (idsUser, key, deviceId) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        pnmac_fetch("".concat(url(getState()), "api/main/bio_metric_auth"), {
          method: 'POST',
          headers: globalHeaders(getState()),
          retryOn: [302, 204],
          body: JSON.stringify({
            idsUserId: idsUser,
            publicKey: key,
            deviceId: deviceId
          })
        }).then(function (res) {
          return res.json();
        }).then(function (s) {
          if (s.apiSuccess) {
            dispatch({
              type: APP_SETTINGS,
              appSettings: __assign(__assign({}, getState().appSettings), {
                isBioEnabled: true
              })
            });
          }
        }).catch(function (err) {
          return null;
        } /** we should handle failures more gracefully */);
        return [2 /*return*/];
      });
    });
  };
};
export var toggleBio = function (deviceId, toggle) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        pnmac_fetch("".concat(url(getState()), "api/main/toggle_bio_on?deviceId=").concat(deviceId, "&&toggle=").concat(toggle, "&&idsUserId=").concat(getState().userProfile.user_id), {
          method: "GET",
          headers: globalHeaders(getState()),
          retryOn: [302, 204, 404]
        }).then(function (data) {
          if (data.status == 200) {
            return data.json();
          }
        }).then(function (res) {
          if (res.apiSuccess) {
            var d = getState().appSettings;
            dispatch({
              type: APP_SETTINGS,
              appSettings: __assign(__assign({}, d), {
                isBioEnabled: toggle
              })
            });
          } else {
            dispatch({
              type: APP_SETTINGS,
              appSettings: __assign(__assign({}, d), {
                isBioEnabled: false
              })
            });
          }
        }).catch(function (e) {
          dispatch({
            type: APP_SETTINGS,
            appSettings: __assign(__assign({}, d), {
              isBioEnabled: false
            })
          });
        });
        return [2 /*return*/];
      });
    });
  };
};
export var getEscrowAnalysisLookBack = function (loanId) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var state;
      return __generator(this, function (_a) {
        state = getState();
        if (parseInt(loanId) > 0) {
          // dispatch({ type: LOADING, act: true })
          dispatch({
            type: GET_ESCROW_ANALYSIS_LOOKBACK,
            escrowAnalysisLookBackData: [],
            loading: true
          });
          fetch("".concat(url(state), "api/loan/get_escrowAnalysisLookback"), {
            method: "POST",
            headers: globalHeaders(getState()),
            body: JSON.stringify({
              loanId: loanId
            })
          }).then(function (data) {
            if (data.status == 200) {
              return data.json();
            } else {
              return null;
            }
          }).then(function (res) {
            var escrowLookBackData = [];
            if (res && res.length > 0) {
              escrowLookBackData = res.length > 1 ? res.sort(function (a, b) {
                return moment(b.analysisEffectiveDate).format('YYYYMMDD') - moment(a.analysisEffectiveDate).format('YYYYMMDD');
              }) : res;
            }
            dispatch({
              type: GET_ESCROW_ANALYSIS_LOOKBACK,
              escrowAnalysisLookBackData: escrowLookBackData,
              loading: false
            });
          }).catch(function (e) {
            // alert('Error' + e);
            dispatch({
              type: GET_ESCROW_ANALYSIS_LOOKBACK,
              escrowAnalysisLookBackData: [],
              loading: false
            });
            console.log("Error getting GET_ESCROW_ANALYSIS_LOOKBACK request", e);
          });
        }
        return [2 /*return*/];
      });
    });
  };
};
export var getPushNotificationConsent = function () {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var state, borrowerId;
      return __generator(this, function (_a) {
        state = getState();
        borrowerId = state.borrowerId;
        pnmac_fetch("".concat(url(state), "api/loan/get_borrower_contact_rules?borrowerID=").concat(borrowerId), {
          method: "GET",
          retries: 4,
          retryOn: [333, 302],
          retryDelay: function (attempt, error, response) {
            return Math.pow(2, attempt) * 1000;
          },
          headers: globalHeaders(state)
        }).then(function (response) {
          if (response.ok) {
            return response.json();
          }
        }).then(function (data) {
          var _a, _b, _c, _d;
          if (((_a = data[0]) === null || _a === void 0 ? void 0 : _a.pushConsentTypeId) !== null) {
            var d = getState().appSettings;
            dispatch({
              type: APP_SETTINGS,
              appSettings: __assign(__assign({}, d), {
                isPushConsent: (_b = data[0]) === null || _b === void 0 ? void 0 : _b.pushConsentTypeId,
                isPushConsentSpecified: ((_c = data[0]) === null || _c === void 0 ? void 0 : _c.pushConsentTypeId) === 1 ? null : ((_d = data[0]) === null || _d === void 0 ? void 0 : _d.pushConsentTypeId) === 2 ? true : false
              })
            });
          }
        });
        return [2 /*return*/];
      });
    });
  };
};
export var updatePushNotificationConsent = function (flag) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var state, borrowerId, requestBody, loanId, trackerSession;
      return __generator(this, function (_a) {
        state = getState();
        borrowerId = state.index_borrower_id;
        requestBody = {
          borrowerId: borrowerId,
          contactRuleScopeId: 1,
          pushConsentTypeId: flag,
          pushConsentAppId: 23,
          pushConsentDate: moment().format("YYYY/MM/DD"),
          pushConsentSpecified: true
        };
        loanId = state.selectedLoanNumber;
        trackerSession = state.trackerSession;
        fetch("".concat(url(getState()), "api/main/publish_ui_tracker"), {
          method: 'POST',
          body: JSON.stringify(eventTracker(loanId, borrowerId, 'English', "Page", 'Action', 'Push Notification Consent', 'update_contact_rule', state.index_borrower_id, requestBody, trackerSession, true)),
          headers: globalHeaders(getState())
        });
        pnmac_fetch("".concat(url(state), "api/loan/update_contact_rule"), {
          method: "PUT",
          retries: 4,
          retryOn: [302, 204],
          retryDelay: function (attempt, error, response) {
            return Math.pow(2, attempt) * 1000;
          },
          headers: globalHeaders(state),
          body: JSON.stringify(requestBody)
        }).then(function (res) {
          if (res.ok) {
            return res.json();
          }
        }).then(function (data) {}).catch(function (error) {});
        return [2 /*return*/];
      });
    });
  };
};
export var getBorrowerContactRules = function (borrowerId) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var state;
      return __generator(this, function (_a) {
        state = getState();
        if (parseInt(borrowerId) > 0) {
          fetch("".concat(url(state), "api/loan/get_borrower_contact_rules?borrowerId=").concat(borrowerId), {
            method: "GET",
            headers: globalHeaders(getState())
          }).then(function (s) {
            return proceed(s);
          }).then(function (response) {
            var rules = [];
            if (response) {
              rules = response;
            }
            dispatch({
              type: FETCH_BORROWER_CONTACT_RULES,
              borrowerContactRules: rules
            });
          }).catch(function (e) {
            dispatch({
              type: FETCH_BORROWER_CONTACT_RULES,
              borrowerContactRules: []
            });
          });
        }
        return [2 /*return*/];
      });
    });
  };
};
export var addNotesToLamp = function (loanId, eventTypeId, message) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var state, data;
      return __generator(this, function (_a) {
        state = getState();
        data = {
          LoanId: loanId,
          EventTypeId: eventTypeId,
          Message: message
        };
        fetch("".concat(url(state), "api/main/AddNotesToLamp"), {
          method: "POST",
          headers: globalHeaders(state),
          body: JSON.stringify(data)
        }).then(function (s) {
          if (s.ok) {}
        }).catch(function (err) {});
        return [2 /*return*/];
      });
    });
  };
};
export var updateBottomTabIconColor = function (screenName) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        dispatch({
          type: UPDATE_BOTTOM_TAB_ICON_COLOR,
          selectedViewForBottomTab: screenName
        });
        return [2 /*return*/];
      });
    });
  };
};